import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'
import type { UseFiltersPayload } from '@domain-group/react-hooks'

import { MainContent, ModalContext, TopBar } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useMainNavigation from '@hooks/useMainNavigation'

import CreateTemplatePagePartialModal from '@modals/CreateTemplatePagePartialModal'

import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import PageContent from './components/PageContent'

export type PageContextPayload = UseFiltersPayload & {
  callbacks: {
    toggleTemplatePagePartialVisibility: (payload: any) => void,
    duplicateTemplatePagePartial: (payload: any) => void,
    createTemplatePagePartial: (payload: any) => void,
    showCreateTemplatePagePartialModal: () => void,
  },
}

const defaultState = {
  showCreateTemplatePagePartialModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
// @ts-expect-error TS2304
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    CreateTemplatePagePartialModal: {
      createTemplatePagePartial: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      closeModal: () => setState({ showCreateTemplatePagePartialModal: false }),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateTemplatePagePartialModal } = state

  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const filtersPayload = useFilters({ persistFilters: true })
  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload

  const modalContext = useModals()
  const { callbacks: { setModalData } } = modalContext

  // @ts-expect-error TS2322
  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateTemplatePagePartialModal: () => setState({ showCreateTemplatePagePartialModal: true }),
      toggleTemplatePagePartialVisibility: payload => handleCallbackAction(payload),
      duplicateTemplatePagePartial: payload => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <TopBar
          callbacks={{ toggleNavigation }}
          loggedInUserComponent={<LoggedInUser />}
          // @ts-expect-error TS2322
          searchComponent={<TopBar.Search callbacks={{ search: null }} />}
        />

        <MainNavigation />

        <MainContent offset={{ top: TopBar.topBarHeight }}>
          <PageContent pageFilters={pageFilters} />
        </MainContent>

        <CreateTemplatePagePartialModal
          callbacks={callbacks('CreateTemplatePagePartialModal', setState)}
          showModal={showCreateTemplatePagePartialModal}
          // @ts-expect-error TS2322
          templatePagePartial={{
            brand_id: null,
            designer_id: null,
            measurement_unit: 'px',
          }}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
